import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

interface TableBlokProps extends Blok {
  table_header_row: Blok[];
  table_rows: Blok[];
  table_layout: '25-75' | '50-50' | '75-25';
}

interface TableProps {
  blok: TableBlokProps;
}

const Table: React.FC<TableProps> = ({ blok }) => {
  const { table_header_row, table_rows, table_layout } = blok;

  return (
    <table
      {...storyblokEditable(blok)}
      className="not-prose w-full table-fixed text-left"
    >
      {table_header_row && (
        <thead>
          {table_header_row.map((row: Blok) => (
            <StoryblokComponent
              blok={{ ...row, table_layout }}
              key={row._uid}
            />
          ))}
        </thead>
      )}
      <tbody>
        {table_rows.map((row: Blok) => (
          <StoryblokComponent blok={{ ...row, table_layout }} key={row._uid} />
        ))}
      </tbody>
    </table>
  );
};

export default memo(Table);
